// PdfViewer.tsx
import React from 'react';

interface PdfViewerProps {
  base64: string;
  height?: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ base64, height = '600px' }) => {
  const pdfDataUrl = `data:application/pdf;base64,${base64}`;

  return (
    <iframe
      title="PDF Viewer"
      src={pdfDataUrl}
      width="100%"
      height={height}
      style={{ border: 'none' }}
    />
  );
};

export default PdfViewer;
